module.exports = __webpack_public_path__ + "static/Mambu_homepage_January2019-25c009dc2282237c5d8f17ecbfca903b.jpg";